import React, { useRef, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import "./PageDateSelector.scss";
import DatePicker from "react-datepicker";
import calendar from "../../assets/PageDateSelector/calendar.svg";
import { PageDateSelectorProps } from "./PageDateSelector.types";
import {
  Container,
  CustomContainer,
  DatePickerContainer,
  DateSelector,
  Icon,
  To,
  customStyles,
  TitleContainer,
  Title,
} from "./PageDateSelector.styles";

export const PageDateSelector: React.FC<PageDateSelectorProps> = ({
  alignRight,
  dateRange,
  setDateRange,
}) => {
  const formatDate = (date: Date, daysPrior?: any) => {
    return daysPrior
      ? new Date(date.setDate(date.getDate() - daysPrior))
          .toISOString()
          .slice(0, 10)
      : date.toISOString().slice(0, 10);
  };

  //const now = new Date();
  const dateOptions = [
    /*
    {
      value: {
        ...dateRange,
        startDate: formatDate(new Date(now.getFullYear(), now.getMonth(), 1)),
        endDate: formatDate(new Date()),
      },
      label: "This Month",
    },
     */
    {
      value: {
        executive: dateRange.executive,
        teamLeadId: dateRange.teamLeadId,
        is30Day: true,
      },
      label: "30 Days",
    },
    {
      value: {
        executive: dateRange.executive,
        teamLeadId: dateRange.teamLeadId,
        is60Day: true,
      },
      label: "60 Days",
    },
    {
      value: {
        executive: dateRange.executive,
        teamLeadId: dateRange.teamLeadId,
        is90Day: true,
      },
      label: "90 Days",
    },
    {
      value: {
        executive: dateRange.executive,
        teamLeadId: dateRange.teamLeadId,
        startDate: formatDate(new Date(), 90),
        endDate: formatDate(new Date()),
      },
      label: "Custom",
    },
  ];

  const [selectedOption, setSelectedOption] = useState(dateOptions[0]);
  const startDatepickerRef = useRef<any>(null);
  const endDatepickerRef = useRef<any>(null);
  const [isCustomTimeFrame, toggleCustomTimeFrame] = useState(false);
  const [customStartDate, setCustomStartDate] = useState(new Date());
  const [customEndDate, setCustomEndDate] = useState(new Date());

  const handleSelectChange = (selectedOption: any) => {
    setSelectedOption(selectedOption);
    setDateRange(selectedOption.value);

    if (selectedOption.label === "Custom") {
      setCustomStartDate(
        new Date(new Date().setDate(new Date().getDate() - 90))
      );
      setCustomEndDate(new Date());
      return toggleCustomTimeFrame(true);
    } else {
      return toggleCustomTimeFrame(false);
    }
  };

  const handleStartDateChange = (date: Date) => {
    const newDateRange = {
      ...dateRange,
      startDate: formatDate(date),
    };

    setCustomStartDate(date);
    setDateRange(newDateRange);
  };

  const handleEndDateChange = (date: Date) => {
    const newDateRange = {
      ...dateRange,
      endDate: formatDate(date),
    };

    setCustomEndDate(date);
    setDateRange(newDateRange);
  };

  const handleStartCalendarClick = () => {
    startDatepickerRef?.current?.setOpen(true);
  };

  const handleEndCalendarClick = () => {
    endDatepickerRef?.current?.setOpen(true);
  };

  return (
    <Container alignRight={alignRight}>
      <TitleContainer>
        <Title>Statistics Time Frame</Title>
        <DateSelector
          defaultValue={selectedOption}
          onChange={handleSelectChange}
          options={dateOptions}
          styles={customStyles}
        />
      </TitleContainer>
      {!isCustomTimeFrame ? null : (
        <CustomContainer id="PageDateSelector">
          <DatePickerContainer>
            <DatePicker
              selected={customStartDate}
              onChange={handleStartDateChange}
              dateFormat="MMM d, yyyy"
              ref={startDatepickerRef}
              maxDate={customEndDate}
            />
            <Icon src={calendar} onClick={handleStartCalendarClick} />
          </DatePickerContainer>
          <To>to</To>
          <DatePickerContainer>
            <DatePicker
              selected={customEndDate}
              onChange={handleEndDateChange}
              dateFormat="MMM d, yyyy"
              ref={endDatepickerRef}
              maxDate={new Date()}
            />
            <Icon src={calendar} onClick={handleEndCalendarClick} />
          </DatePickerContainer>
        </CustomContainer>
      )}
    </Container>
  );
};
